// AUTO-GENERATED CODE, DO NOT EDIT!
//
// These types are generated from the schema
// base types and should not be used
//
/* eslint-disable */

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: any
}

export enum Audience {
  Personal = 'personal',
  Professional = 'professional',
}

export type Collection = {
  __typename?: 'Collection'
  id: Scalars['Int']
  label: Scalars['String']
}

export enum ContactStatus {
  Contacted = 'contacted',
  Lost = 'lost',
  New = 'new',
  Won = 'won',
}

export type Contract = {
  __typename?: 'Contract'
  country: Scalars['String']
  endDate?: Maybe<Scalars['DateTime']>
  id: Scalars['Int']
  rejectedAt?: Maybe<Scalars['DateTime']>
  requestSource: ContractRequestSource
  requestedAt?: Maybe<Scalars['DateTime']>
  startDate?: Maybe<Scalars['DateTime']>
  status: ContractStatus
  type: ContractType
  user?: Maybe<User>
  userId: Scalars['Int']
}

export type ContractFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']>
  expired?: InputMaybe<Scalars['Boolean']>
  pending?: InputMaybe<Scalars['Boolean']>
  regions?: InputMaybe<Array<Scalars['String']>>
  userId?: InputMaybe<Scalars['Int']>
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
}

export enum ContractRequestSource {
  Admin = 'admin',
  Host = 'host',
}

export enum ContractSortField {
  EndDate = 'endDate',
  RejectedAt = 'rejectedAt',
  RequestedAt = 'requestedAt',
  StartDate = 'startDate',
}

export type ContractSortInput = {
  direction: SortDirection
  field: ContractSortField
}

export enum ContractStatus {
  Accepted = 'accepted',
  Deleted = 'deleted',
  PendingRequest = 'pending_request',
  Rejected = 'rejected',
}

export enum ContractType {
  Basic = 'basic',
  NoContract = 'no_contract',
  Premium = 'premium',
  Professional = 'professional',
}

export type ContractsFilter = {
  /** When 'active' is set to true, only confirmed, in-date contracts will be returned */
  active?: InputMaybe<Scalars['Boolean']>
}

export type ContractsPage = {
  __typename?: 'ContractsPage'
  page: Page
  rows: Array<Contract>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

export type CronReminderReturn = {
  __typename?: 'CronReminderReturn'
  receivedButNotSeen?: Maybe<Array<Scalars['Int']>>
  seenButNotActioned?: Maybe<Array<Scalars['Int']>>
}

export type DeclineReason = {
  __typename?: 'DeclineReason'
  id: Scalars['String']
  text: Scalars['String']
}

export enum DeclineSource {
  MessagePage = 'message_page',
  QuickDecline = 'quick_decline',
}

export type EnquiriesPage = {
  __typename?: 'EnquiriesPage'
  page?: Maybe<Page>
  rows?: Maybe<Array<Maybe<Enquiry>>>
  totalPages?: Maybe<Scalars['Int']>
  totalRows?: Maybe<Scalars['Int']>
}

export type Enquiry = {
  __typename?: 'Enquiry'
  allHostNotificationsSentAt?: Maybe<Scalars['DateTime']>
  audience: Audience
  briefId?: Maybe<Scalars['Int']>
  budget: Scalars['Int']
  capacity?: Maybe<Scalars['Int']>
  cateringNeeds?: Maybe<Scalars['String']>
  closedSource?: Maybe<EnquiryClosedSource>
  collection: Collection
  collectionId?: Maybe<Scalars['Int']>
  country: Scalars['String']
  createDate: Scalars['DateTime']
  currency: Scalars['String']
  /** Returns true if both this enquiry was created as a Direct Enquiry, and that direct enquiry was sent to one of the current user's venues (At the time the enquiry was created) */
  directEnquiryToUser: Scalars['Boolean']
  eventDateFrom: Scalars['DateTime']
  eventDateTo: Scalars['DateTime']
  eventMacroType?: Maybe<Scalars['String']>
  eventType?: Maybe<Scalars['String']>
  /** @deprecated We now distuinguish between optional and required space facilities. Use optional/requiredSpaceFacilityIds */
  featureIds: Array<Scalars['Int']>
  /** @deprecated We now distuinguish between optional and required space facilities. Use optional/requiredSpaceFacilities */
  features?: Maybe<Array<Feature>>
  flexibility: Flexibility
  /** @deprecated Use the new flexibility entity */
  flexibleDates: Scalars['Boolean']
  /** @deprecated Use the new flexibility entity */
  flexibleDatesNote?: Maybe<Scalars['String']>
  guest?: Maybe<Guest>
  guestId: Scalars['Int']
  guestNotificationBatchIndex: Scalars['Int']
  guestsCount: Scalars['Int']
  hasPriorityVisibilityEnabled?: Maybe<Scalars['Boolean']>
  hostId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  /** Returns True if the current actor has marked this lead as one they are "not interested". Note that is is unrelated to the concept of "Interested Guests" or Interest objects.  */
  isMarkedAsNotInterestedByUser: Scalars['Boolean']
  /** Returns True if the current actor has marked this lead as read */
  isReadByUser: Scalars['Boolean']
  isStarredByUser: Scalars['Boolean']
  latitude: Scalars['Float']
  layout: Scalars['String']
  location: Scalars['String']
  longitude: Scalars['Float']
  messages: Array<Message>
  messagesCount?: Maybe<Scalars['Int']>
  notes?: Maybe<Scalars['String']>
  optionalSpaceFacilities: Array<Feature>
  optionalSpaceFacilityIds: Array<Scalars['Int']>
  postalCode?: Maybe<Scalars['String']>
  preferredContactMethods: Array<EnquiryContactPreference>
  publicPostalCode?: Maybe<Scalars['String']>
  radius: Scalars['Float']
  /** [ADMIN ONLY] The readWriteAccessSecret to access this enquiry without being logged in */
  readWriteAccessSecret: Scalars['String']
  /** Optionally specify a host for the relevancy fit rating lookup. Defaults to logged in user. */
  relevancyFit: RelevancyFit
  requiredSpaceFacilities: Array<Feature>
  requiredSpaceFacilityIds: Array<Scalars['Int']>
  source: EnquirySource
  spaceId?: Maybe<Scalars['Int']>
  spaceName?: Maybe<Scalars['String']>
  spaceStyleIds?: Maybe<Array<Scalars['String']>>
  spaceStyles?: Maybe<Array<SpaceStyle>>
  status: EnquiryStatus
  timeSlots: Scalars['String']
  timings?: Maybe<Scalars['String']>
  title: Scalars['String']
  /**
   * Returns True if the current actor has a valid active contract required to send a message in response to this enquiry
   * If false, using the CreateMessage mutation will result in an error
   */
  userAuthorisedToMessage: Scalars['Boolean']
  uuid: Scalars['String']
  venue?: Maybe<Venue>
  venueDescription?: Maybe<Scalars['String']>
  venueId?: Maybe<Scalars['Int']>
  venueLatitude?: Maybe<Scalars['Float']>
  venueLongitude?: Maybe<Scalars['Float']>
  venueName?: Maybe<Scalars['String']>
  visibleToHostDate: Scalars['DateTime']
}

export type EnquiryMessagesCountArgs = {
  includeDeclined?: InputMaybe<Scalars['Boolean']>
}

export type EnquiryRelevancyFitArgs = {
  hostId?: InputMaybe<Scalars['Int']>
}

export type EnquiryVisibleToHostDateArgs = {
  hostId?: InputMaybe<Scalars['Int']>
}

export enum EnquiryClosedSource {
  Admin = 'admin',
  EnquiryPage = 'enquiry_page',
  Modal = 'modal',
}

export enum EnquiryContactPreference {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Text = 'TEXT',
}

export type EnquiryFiltersInput = {
  collectionIds?: InputMaybe<Array<Scalars['Int']>>
  eventTypes?: InputMaybe<Array<Scalars['String']>>
  excludeClosed?: InputMaybe<Scalars['Boolean']>
  excludeHostIds?: InputMaybe<Array<Scalars['Int']>>
  excludeMessaged?: InputMaybe<Scalars['Boolean']>
  excludeNotInterested?: InputMaybe<Scalars['Boolean']>
  excludePoorFits?: InputMaybe<Scalars['Boolean']>
  excludePriorityBlocked?: InputMaybe<Scalars['Boolean']>
  filterSetId?: InputMaybe<Scalars['Int']>
  fromEventDate?: InputMaybe<Scalars['String']>
  guestId?: InputMaybe<Scalars['Int']>
  guestIds?: InputMaybe<Array<Scalars['Int']>>
  hasUnsentNotifications?: InputMaybe<Scalars['Boolean']>
  hostId?: InputMaybe<Scalars['Int']>
  maxAgeInDays?: InputMaybe<Scalars['Int']>
  maxBudget?: InputMaybe<Scalars['Int']>
  maxCapacity?: InputMaybe<Scalars['Int']>
  maxGuestsCount?: InputMaybe<Scalars['Int']>
  maxNotificationBatchesSent?: InputMaybe<Scalars['Int']>
  minBudget?: InputMaybe<Scalars['Int']>
  minCapacity?: InputMaybe<Scalars['Int']>
  minGuestsCount?: InputMaybe<Scalars['Int']>
  postalCodes?: InputMaybe<Array<PostalCode>>
  regions?: InputMaybe<Array<Scalars['String']>>
  showOnly?: InputMaybe<Array<EnquiryShowOption>>
  statuses?: InputMaybe<Array<EnquiryStatus>>
}

export type EnquirySearchFields = {
  /** Uses case-insensitive substring matching */
  guestEmail?: InputMaybe<Scalars['String']>
}

export enum EnquiryShowOption {
  GoodFit = 'GOOD_FIT',
  Starred = 'STARRED',
  Unread = 'UNREAD',
}

export enum EnquirySortField {
  Budget = 'budget',
  CreateDate = 'createDate',
  EventDate = 'eventDate',
  EventType = 'eventType',
  GuestsCount = 'guestsCount',
  Id = 'id',
  RelevancyFit = 'relevancyFit',
}

export type EnquirySortInput = {
  direction: SortDirection
  field: EnquirySortField
}

export enum EnquirySource {
  BriefBuilder = 'BriefBuilder',
  HeadBox = 'HeadBox',
}

export enum EnquiryStatus {
  Active = 'active',
  Closed = 'closed',
  Duplicated = 'duplicated',
  Old = 'old',
  Private = 'private',
  Takenbyams = 'takenbyams',
  Unqualifiable = 'unqualifiable',
}

export type EnquiryUpdateInput = {
  contactDetails: Array<EnquiryContactPreference>
}

export type Feature = {
  __typename?: 'Feature'
  id: Scalars['Int']
  name: Scalars['String']
}

export type FeatureCategory = {
  __typename?: 'FeatureCategory'
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
  searchable?: Maybe<Scalars['Boolean']>
}

export type FilterSet = {
  __typename?: 'FilterSet'
  audience: Array<Audience>
  /** Whether the minBudget is per head or for the entire enquiry. */
  budgetPerHead?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  /** Days of week are represented as numbers from 0 to 6, where 0 is Sunday and 6 is Saturday. */
  daysOfWeek?: Maybe<Array<Scalars['Int']>>
  email: Scalars['String']
  eventTypeIds?: Maybe<Array<Scalars['Int']>>
  excludedFacilities?: Maybe<Array<Scalars['Int']>>
  id: Scalars['Int']
  isDefaultFilter: Scalars['Boolean']
  maxCapacity?: Maybe<Scalars['Int']>
  /** The minimum budget for the filter set. If budgetPerHead is true, this is the minimum budget per head, otherwise it is the minimum budget for the enquiry. */
  minBudget?: Maybe<Scalars['Int']>
  minCapacity?: Maybe<Scalars['Int']>
  /** Month of the year (1-12) */
  monthsOfYear?: Maybe<Array<Scalars['Int']>>
  name: Scalars['String']
  sendNotificationsFor: SendNotificationsForOption
  userId: Scalars['Int']
  userModifiedAt?: Maybe<Scalars['DateTime']>
  venueIds?: Maybe<Array<Scalars['Int']>>
}

export type FilterSetCreationInput = {
  audience?: InputMaybe<Array<Audience>>
  /** Whether the minBudget is per head or for the entire enquiry. */
  budgetPerHead?: InputMaybe<Scalars['Boolean']>
  /** Days of week are represented as numbers from 0 to 6, where 0 is Sunday and 6 is Saturday. */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>
  email?: InputMaybe<Scalars['String']>
  eventTypeIds?: InputMaybe<Array<Scalars['Int']>>
  excludedFacilities?: InputMaybe<Array<Scalars['Int']>>
  maxCapacity?: InputMaybe<Scalars['Int']>
  /** The minimum budget for the filter set. If budgetPerHead is true, this is the minimum budget per head, otherwise it is the minimum budget for the enquiry. */
  minBudget?: InputMaybe<Scalars['Int']>
  minCapacity?: InputMaybe<Scalars['Int']>
  /** Month of the year (1-12) */
  monthsOfYear?: InputMaybe<Array<Scalars['Int']>>
  name: Scalars['String']
  sendNotificationsFor: SendNotificationsForOption
  venueIds?: InputMaybe<Array<Scalars['Int']>>
}

export type FilterSetUpdateInput = {
  audience?: InputMaybe<Array<Audience>>
  /** Whether the minBudget is per head or for the entire enquiry. */
  budgetPerHead?: InputMaybe<Scalars['Boolean']>
  /** Days of week are represented as numbers from 0 to 6, where 0 is Sunday and 6 is Saturday. */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>
  email?: InputMaybe<Scalars['String']>
  eventTypeIds?: InputMaybe<Array<Scalars['Int']>>
  excludedFacilities?: InputMaybe<Array<Scalars['Int']>>
  maxCapacity?: InputMaybe<Scalars['Int']>
  /** The minimum budget for the filter set. If budgetPerHead is true, this is the minimum budget per head, otherwise it is the minimum budget for the enquiry. */
  minBudget?: InputMaybe<Scalars['Int']>
  minCapacity?: InputMaybe<Scalars['Int']>
  /** Month of the year (1-12) */
  monthsOfYear?: InputMaybe<Array<Scalars['Int']>>
  name?: InputMaybe<Scalars['String']>
  sendNotificationsFor: SendNotificationsForOption
  venueIds?: InputMaybe<Array<Scalars['Int']>>
}

export type Flexibility = {
  __typename?: 'Flexibility'
  flexibleDates: Scalars['Boolean']
  flexibleTimes: Scalars['Boolean']
  notes?: Maybe<Scalars['String']>
}

export type GexpReminderEmailFilters = {
  enquiryYoungerThanInDays: Scalars['Int']
  messageOlderThanInHours: Scalars['Int']
}

export type GrantAccessInput = {
  endDate: Scalars['DateTime']
  isPowerHost: Scalars['Boolean']
  requestSource: ContractRequestSource
  type: ContractType
  userId: Scalars['Int']
}

export type Guest = {
  __typename?: 'Guest'
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  mobileNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type GuestEnquiry = {
  __typename?: 'GuestEnquiry'
  createDate?: Maybe<Scalars['DateTime']>
  enquiryId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  messageId?: Maybe<Scalars['Int']>
  notes?: Maybe<Scalars['String']>
}

export type HostListingsSpace = {
  __typename?: 'HostListingsSpace'
  deleted?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  /** You must provide the id of the enquiry for which relevancy will be calculated. (The host for the calculation is the actor.) */
  relevancyScore?: Maybe<Scalars['Float']>
  spaceDocuments?: Maybe<Array<Maybe<SpaceDocument>>>
  spaceName?: Maybe<Scalars['String']>
  spacePhotos?: Maybe<Array<Maybe<SpacePhoto>>>
  status?: Maybe<SpaceStatus>
  tour3dUrl?: Maybe<Scalars['String']>
  user?: Maybe<User>
}

export type HostListingsSpaceRelevancyScoreArgs = {
  forEnquiry: Scalars['Int']
}

export type HostListingsVenue = {
  __typename?: 'HostListingsVenue'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  deletedAt?: Maybe<Scalars['DateTime']>
  hasPublishedSpaces?: Maybe<Scalars['Boolean']>
  id: Scalars['Int']
  latitude?: Maybe<Scalars['Float']>
  leadFeedEnabled: Scalars['Boolean']
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  spaces: Array<HostListingsSpace>
  state?: Maybe<Scalars['String']>
}

export type HostListingsVenueSpacesArgs = {
  includeUnpublished?: InputMaybe<Scalars['Boolean']>
}

export type Interest = {
  __typename?: 'Interest'
  contactStatus: ContactStatus
  contactedAt?: Maybe<Scalars['DateTime']>
  enquiry: Enquiry
  enquiryId: Scalars['Int']
  guest: User
  guestId: Scalars['Int']
  guestInitiated: Scalars['Boolean']
  host: User
  hostId: Scalars['Int']
  id: Scalars['Int']
  matched: Scalars['Boolean']
  matchedAt?: Maybe<Scalars['DateTime']>
  message?: Maybe<Message>
  /**
   * true if the interest is associated with a message that has been declined
   * false if the interest is associated with a message that has not been declined
   * null if the interest is not associated with a message (i.e. is a direct enquiry)
   */
  messageDeclined?: Maybe<Scalars['Boolean']>
  messageId?: Maybe<Scalars['Int']>
  recommended: Scalars['Boolean']
}

export type InterestFiltersInput = {
  enquiryAccessSecret?: InputMaybe<Scalars['String']>
  enquiryId?: InputMaybe<Scalars['Int']>
  enquiryIds?: InputMaybe<Array<Scalars['Int']>>
  enquiryUUID?: InputMaybe<Scalars['String']>
  guestId?: InputMaybe<Scalars['Int']>
  guestInitiated?: InputMaybe<Scalars['Boolean']>
  hostId?: InputMaybe<Scalars['Int']>
  matched?: InputMaybe<Scalars['Boolean']>
  /**
   * If true only includes interests associated with messages that have been declined
   * If false only includes interests associated with messages that have not been declined
   * If set will always exclude direct enquiries
   */
  messageDeclined?: InputMaybe<Scalars['Boolean']>
  regions?: InputMaybe<Array<Scalars['String']>>
}

export enum InterestSortField {
  Budget = 'budget',
  CreatedAt = 'createdAt',
  EventDateFrom = 'eventDateFrom',
  EventType = 'eventType',
  GuestsCount = 'guestsCount',
  Id = 'id',
  MatchedAt = 'matchedAt',
}

export type InterestSortInput = {
  direction: SortDirection
  field: InterestSortField
}

export type InterestsPage = {
  __typename?: 'InterestsPage'
  page: Page
  rows: Array<Interest>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

export type LeadFeedEnabledInput = {
  id: Scalars['Int']
  leadFeedEnabled: Scalars['Boolean']
}

export type Message = {
  __typename?: 'Message'
  cardSeen: Scalars['Boolean']
  cardSeenAt?: Maybe<Scalars['DateTime']>
  creationDate: Scalars['DateTime']
  declineSource?: Maybe<DeclineSource>
  declined: Scalars['Boolean']
  declinedAt?: Maybe<Scalars['DateTime']>
  declinedReasons: Array<DeclineReason>
  email: Scalars['String']
  enquiry?: Maybe<Enquiry>
  enquiryId: Scalars['Int']
  guest: Guest
  guestEnquiry?: Maybe<GuestEnquiry>
  host: User
  hostId: Scalars['Int']
  id: Scalars['Int']
  interestExpressed: Scalars['Boolean']
  interestExpressedAt?: Maybe<Scalars['DateTime']>
  matchAttemptedAt?: Maybe<Scalars['DateTime']>
  originalVenue?: Maybe<MessageVenue>
  phone?: Maybe<Scalars['String']>
  receiver: User
  receiverId: Scalars['Int']
  relevancyFit: RelevancyFit
  reviewDate?: Maybe<Scalars['DateTime']>
  seen: Scalars['Boolean']
  seenAt?: Maybe<Scalars['DateTime']>
  status: MessageStatus
  text: Scalars['String']
  title: Scalars['String']
  uuid: Scalars['String']
  venue?: Maybe<Venue>
}

export type MessageFiltersInput = {
  declined?: InputMaybe<Scalars['Boolean']>
  enquiryUUID?: InputMaybe<Scalars['String']>
  hostId?: InputMaybe<Scalars['Int']>
  interestExpressed?: InputMaybe<Scalars['Boolean']>
  receiverId?: InputMaybe<Scalars['Int']>
}

export type MessageInput = {
  email: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  text: Scalars['String']
  venueId: Scalars['Int']
}

export enum MessageSortField {
  Budget = 'budget',
  CreationDate = 'creationDate',
  EventDateFrom = 'eventDateFrom',
  EventType = 'eventType',
  GuestsCount = 'guestsCount',
  Id = 'id',
  InterestExpressedAt = 'interestExpressedAt',
}

export type MessageSortInput = {
  direction: SortDirection
  field: MessageSortField
}

export enum MessageStatus {
  Created = 'CREATED',
  HeldUntilNextBatch = 'HELD_UNTIL_NEXT_BATCH',
  Reviewed = 'REVIEWED',
  Send = 'SEND',
  SendFail = 'SEND_FAIL',
}

export type MessageVenue = {
  __typename?: 'MessageVenue'
  description?: Maybe<Scalars['String']>
  hostId: Scalars['Int']
  id: Scalars['Int']
  name: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type MessagesPage = {
  __typename?: 'MessagesPage'
  page: Page
  rows: Array<Message>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

export type Mutation = {
  __typename?: 'Mutation'
  ChangeContractExpiryDate?: Maybe<Contract>
  ChangeContractType?: Maybe<Contract>
  CloseEnquiryByAccessSecret?: Maybe<Enquiry>
  CloseEnquiryByUUID?: Maybe<Enquiry>
  CreateDirectInterest?: Maybe<Interest>
  CreateFilterSet: FilterSet
  CreateMessage?: Maybe<Message>
  CreateReminder: Reminder
  CreateTemplate: Template
  DeclineMessage: Message
  DeleteFilterSet?: Maybe<FilterSet>
  /** @deprecated use DeleteFilterSet */
  DeleteNotificationPreferences?: Maybe<Scalars['Boolean']>
  DeleteTemplate: Scalars['Boolean']
  DuplicateFilterSet: FilterSet
  EnquireFromMessage?: Maybe<GuestEnquiry>
  ExpressInterest?: Maybe<Message>
  GrantHostAccess?: Maybe<Contract>
  MarkAsSeen: Message
  MarkCardAsSeen: Message
  RecordMatchAttempt: Message
  RecordViewOptions?: Maybe<Scalars['String']>
  RejectPendingContract?: Maybe<Contract>
  RequestAccess?: Maybe<Contract>
  ReviewMessage?: Maybe<Message>
  SendGEXPReminders?: Maybe<CronReminderReturn>
  SendGEXPRemindersDryRun?: Maybe<CronReminderReturn>
  SendWeeklyUpdate: Array<Scalars['Int']>
  SendWeeklyUpdateDryRun: Array<Scalars['Int']>
  /** Sets the enquiry to be read *by* this actor */
  SetEnquiryAsRead?: Maybe<Enquiry>
  /** Sets the enquiry "Not Interested" status *for* this actor. Note that is is unrelated to the concept of "Interested Guests" or Interest objects.  */
  SetEnquiryNotInterested: Enquiry
  /** Sets the enquiry's starred status *for* this actor  */
  SetEnquiryStarred: Enquiry
  SetInterestContactStatus?: Maybe<Interest>
  /** @deprecated use UpdateFilterSet */
  SetNotificationPreferences?: Maybe<NotificationPreference>
  UpdateContract?: Maybe<Contract>
  UpdateEnquiry: Enquiry
  UpdateEnquiryStatus?: Maybe<Enquiry>
  UpdateEnquiryUserDetails?: Maybe<User>
  UpdateFilterSet: FilterSet
  UpdateTemplate: Template
  UpdateVenueLeadFeedStatuses: Array<HostListingsVenue>
}

export type MutationChangeContractExpiryDateArgs = {
  contractId: Scalars['Int']
  date?: InputMaybe<Scalars['DateTime']>
}

export type MutationChangeContractTypeArgs = {
  contractId: Scalars['Int']
  type: ContractType
}

export type MutationCloseEnquiryByAccessSecretArgs = {
  accessSecret: Scalars['String']
  closedSource?: InputMaybe<EnquiryClosedSource>
}

export type MutationCloseEnquiryByUuidArgs = {
  closedSource?: InputMaybe<EnquiryClosedSource>
  enquiryUUID: Scalars['String']
}

export type MutationCreateDirectInterestArgs = {
  enquiryId: Scalars['Int']
}

export type MutationCreateFilterSetArgs = {
  filterSet: FilterSetCreationInput
}

export type MutationCreateMessageArgs = {
  enquiryId: Scalars['Int']
  message: MessageInput
}

export type MutationCreateReminderArgs = {
  reminder: ReminderInput
}

export type MutationCreateTemplateArgs = {
  template: TemplateInput
}

export type MutationDeclineMessageArgs = {
  accessSecret: Scalars['String']
  declineSource: DeclineSource
  messageId: Scalars['Int']
  otherReason?: InputMaybe<Scalars['String']>
  reasons: Array<Scalars['String']>
}

export type MutationDeleteFilterSetArgs = {
  id: Scalars['Int']
}

export type MutationDeleteTemplateArgs = {
  uuid: Scalars['String']
}

export type MutationDuplicateFilterSetArgs = {
  id: Scalars['Int']
}

export type MutationEnquireFromMessageArgs = {
  messageId: Scalars['Int']
  notes?: InputMaybe<Scalars['String']>
}

export type MutationExpressInterestArgs = {
  messageId: Scalars['Int']
}

export type MutationGrantHostAccessArgs = {
  params: GrantAccessInput
}

export type MutationMarkAsSeenArgs = {
  accessSecret: Scalars['String']
  messageId: Scalars['Int']
}

export type MutationMarkCardAsSeenArgs = {
  accessSecret: Scalars['String']
  messageId: Scalars['Int']
}

export type MutationRecordMatchAttemptArgs = {
  accessSecret: Scalars['String']
  messageId: Scalars['Int']
}

export type MutationRecordViewOptionsArgs = {
  viewOptions: ViewOptionsInput
}

export type MutationRejectPendingContractArgs = {
  contractId: Scalars['Int']
}

export type MutationReviewMessageArgs = {
  messageUUID: Scalars['String']
}

export type MutationSendGexpRemindersArgs = {
  filters?: InputMaybe<GexpReminderEmailFilters>
}

export type MutationSendGexpRemindersDryRunArgs = {
  filters?: InputMaybe<GexpReminderEmailFilters>
}

export type MutationSetEnquiryAsReadArgs = {
  id: Scalars['Int']
}

export type MutationSetEnquiryNotInterestedArgs = {
  id: Scalars['Int']
  notInterested: Scalars['Boolean']
}

export type MutationSetEnquiryStarredArgs = {
  id: Scalars['Int']
  isStarred: Scalars['Boolean']
}

export type MutationSetInterestContactStatusArgs = {
  contactStatus: ContactStatus
  interestId: Scalars['Int']
}

export type MutationSetNotificationPreferencesArgs = {
  notificationPreferences: NotificationPreferenceInput
}

export type MutationUpdateContractArgs = {
  params: UpdateContractInput
}

export type MutationUpdateEnquiryArgs = {
  accessSecret: Scalars['String']
  enquiry: EnquiryUpdateInput
}

export type MutationUpdateEnquiryStatusArgs = {
  id: Scalars['Int']
  status: EnquiryStatus
}

export type MutationUpdateEnquiryUserDetailsArgs = {
  accessSecret: Scalars['String']
  userDetails: UserDetailsInput
}

export type MutationUpdateFilterSetArgs = {
  filterSet: FilterSetUpdateInput
  id: Scalars['Int']
}

export type MutationUpdateTemplateArgs = {
  template: TemplateInput
}

export type MutationUpdateVenueLeadFeedStatusesArgs = {
  venues: Array<LeadFeedEnabledInput>
}

export type NearestTransit = {
  __typename?: 'NearestTransit'
  distance_km: Scalars['Float']
  station: Scalars['String']
  transit_type: Array<Scalars['String']>
}

/** DEPRICATED: use FilterSet */
export type NotificationPreference = {
  __typename?: 'NotificationPreference'
  email?: Maybe<Scalars['String']>
  enabled?: Maybe<Scalars['Boolean']>
  eventTypeIds?: Maybe<Array<Scalars['Int']>>
  maxCapacity?: Maybe<Scalars['Int']>
  minBudget?: Maybe<Scalars['Int']>
  userId?: Maybe<Scalars['Int']>
}

/** DEPRICATED: use FilterSetInput */
export type NotificationPreferenceInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  eventTypeIds?: InputMaybe<Array<Scalars['Int']>>
  maxCapacity?: InputMaybe<Scalars['Int']>
  minBudget?: InputMaybe<Scalars['Int']>
}

export type Page = {
  __typename?: 'Page'
  hasNextPage: Scalars['Boolean']
  number: Scalars['Int']
  size: Scalars['Int']
}

export type PageInput = {
  number: Scalars['Int']
  size: Scalars['Int']
}

export enum PostalCode {
  E = 'E',
  Ec = 'EC',
  N = 'N',
  Nw = 'NW',
  Se = 'SE',
  Sw = 'SW',
  W = 'W',
  Wc = 'WC',
}

export type Query = {
  __typename?: 'Query'
  collections?: Maybe<Array<Maybe<Collection>>>
  contractsPage?: Maybe<ContractsPage>
  declineReasons: Array<DeclineReason>
  enquiriesPage?: Maybe<EnquiriesPage>
  enquiry?: Maybe<Enquiry>
  enquiryByAccessSecret?: Maybe<Enquiry>
  enquiryByUUID?: Maybe<Enquiry>
  features?: Maybe<Array<Maybe<Feature>>>
  filterSetById: FilterSet
  interestsPage?: Maybe<InterestsPage>
  me?: Maybe<User>
  messagesPage?: Maybe<MessagesPage>
  myFilterSets: Array<FilterSet>
  /** @deprecated use myFilterSets */
  myNotificationPreferences?: Maybe<NotificationPreference>
  notificationPreferencesByUser?: Maybe<NotificationPreference>
  reminder?: Maybe<Reminder>
  reviewMessages?: Maybe<MessagesPage>
  template?: Maybe<Template>
  templates: Array<Template>
  userByIdOrEmail?: Maybe<User>
  usersByEmail?: Maybe<Array<Maybe<User>>>
  venueById?: Maybe<Venue>
  venuesByUser?: Maybe<Array<Maybe<Venue>>>
}

export type QueryContractsPageArgs = {
  filter?: InputMaybe<ContractFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<ContractSortInput>
}

export type QueryEnquiriesPageArgs = {
  filter?: InputMaybe<EnquiryFiltersInput>
  page?: InputMaybe<PageInput>
  search?: InputMaybe<EnquirySearchFields>
  sort?: InputMaybe<EnquirySortInput>
}

export type QueryEnquiryArgs = {
  id: Scalars['Int']
}

export type QueryEnquiryByAccessSecretArgs = {
  enquiryAccessSecret: Scalars['String']
}

export type QueryEnquiryByUuidArgs = {
  uuid: Scalars['String']
}

export type QueryFilterSetByIdArgs = {
  filterSetId: Scalars['Int']
}

export type QueryInterestsPageArgs = {
  filter?: InputMaybe<InterestFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<InterestSortInput>
}

export type QueryMessagesPageArgs = {
  filter?: InputMaybe<MessageFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<MessageSortInput>
}

export type QueryNotificationPreferencesByUserArgs = {
  userId: Scalars['Int']
}

export type QueryReminderArgs = {
  id: Scalars['Int']
}

export type QueryReviewMessagesArgs = {
  enquiryUUID: Scalars['String']
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<MessageSortInput>
}

export type QueryTemplateArgs = {
  uuid: Scalars['String']
}

export type QueryTemplatesArgs = {
  userId?: InputMaybe<Scalars['Int']>
}

export type QueryUserByIdOrEmailArgs = {
  idOrEmail: Scalars['ID']
}

export type QueryUsersByEmailArgs = {
  email: Scalars['String']
}

export type QueryVenueByIdArgs = {
  id: Scalars['ID']
}

export enum RelevancyFit {
  Average = 'average',
  Good = 'good',
  Poor = 'poor',
}

export type Reminder = {
  __typename?: 'Reminder'
  createdAt?: Maybe<Scalars['DateTime']>
  enquiryId: Scalars['Int']
  id: Scalars['Int']
  reminderType: ReminderType
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type ReminderInput = {
  enquiryId: Scalars['Int']
  reminderType: ReminderType
}

export enum ReminderType {
  Received = 'RECEIVED',
  Seen = 'SEEN',
}

export enum SendNotificationsForOption {
  All = 'all',
  GoodOnly = 'good_only',
  None = 'none',
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortInput = {
  direction: SortDirection
  field: Scalars['String']
}

export type SpaceDocument = {
  __typename?: 'SpaceDocument'
  filename?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  url?: Maybe<Scalars['String']>
}

export type SpaceFeature = {
  __typename?: 'SpaceFeature'
  featureCategory?: Maybe<FeatureCategory>
  featureCategoryId?: Maybe<Scalars['Int']>
  icon?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
}

export type SpacePhoto = {
  __typename?: 'SpacePhoto'
  filename?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  url?: Maybe<Scalars['String']>
}

export enum SpaceStatus {
  Complete = 'complete',
  Overview = 'overview',
  Published = 'published',
  Reviewed = 'reviewed',
  UnderReview = 'under_review',
}

export type SpaceStyle = {
  __typename?: 'SpaceStyle'
  id: Scalars['String']
  label: Scalars['String']
}

export type SpatialConfiguration = {
  __typename?: 'SpatialConfiguration'
  capacity?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export enum SubscriptionStatus {
  Requested = 'requested',
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
}

export type Template = {
  __typename?: 'Template'
  deletedAt?: Maybe<Scalars['DateTime']>
  email: Scalars['String']
  lastUpdated?: Maybe<Scalars['DateTime']>
  message: Scalars['String']
  name: Scalars['String']
  phoneNumber?: Maybe<Scalars['String']>
  uuid: Scalars['String']
}

export type TemplateInput = {
  email: Scalars['String']
  message: Scalars['String']
  name: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  uuid?: InputMaybe<Scalars['String']>
}

export type UpdateContractInput = {
  contractId: Scalars['Int']
  endDate: Scalars['DateTime']
  isPowerHost: Scalars['Boolean']
  requestSource: ContractRequestSource
  type: ContractType
  userId: Scalars['Int']
}

export type User = {
  __typename?: 'User'
  avatar?: Maybe<Scalars['String']>
  companyLogo?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  contracts?: Maybe<Array<Contract>>
  country?: Maybe<Scalars['String']>
  email: Scalars['String']
  filterSets?: Maybe<Array<FilterSet>>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isPowerHost: Scalars['Boolean']
  jobTitle?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  mobileNumber?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  powerHostExpiresAt?: Maybe<Scalars['DateTime']>
  regions?: Maybe<Array<Scalars['String']>>
  roles?: Maybe<Array<Scalars['String']>>
  subscribed?: Maybe<Scalars['Boolean']>
  subscriptionStatus?: Maybe<SubscriptionStatus>
  /** We could add a filter here to make the resolver extra flexible */
  venues: Array<HostListingsVenue>
  widgetBacklinkMandatory?: Maybe<Scalars['Boolean']>
}

export type UserContractsArgs = {
  filter?: InputMaybe<ContractsFilter>
}

export type UserDetailsInput = {
  phoneNumber: Scalars['String']
}

export type Venue = {
  __typename?: 'Venue'
  address?: Maybe<VenueAddress>
  borough?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  documents?: Maybe<Array<VenueDocument>>
  hostId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  imageUrl?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  leadFeedEnabled: Scalars['Boolean']
  longitude?: Maybe<Scalars['Float']>
  maxCapacity?: Maybe<Scalars['Int']>
  name: Scalars['String']
  nearestTransit?: Maybe<NearestTransit>
  photos?: Maybe<Array<VenuePhoto>>
  published?: Maybe<Scalars['Boolean']>
  spaceFeatures: Array<SpaceFeature>
  spaceName?: Maybe<Scalars['String']>
  spatialConfigurations: Array<SpatialConfiguration>
  tour3dUrl?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
  venueId?: Maybe<Scalars['Int']>
}

export type VenueAddress = {
  __typename?: 'VenueAddress'
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
}

export type VenueDocument = {
  __typename?: 'VenueDocument'
  name: Scalars['String']
  url: Scalars['String']
}

export type VenuePhoto = {
  __typename?: 'VenuePhoto'
  listingsUrl?: Maybe<Scalars['String']>
  thumbUrl?: Maybe<Scalars['String']>
}

export type ViewOptions = {
  __typename?: 'ViewOptions'
  hideMessaged: Scalars['Boolean']
  hideNotInterested: Scalars['Boolean']
  hidePoorFit: Scalars['Boolean']
  hideResponsesClosed: Scalars['Boolean']
  hostId: Scalars['Int']
  id: Scalars['Int']
  showOnlyGoodFit: Scalars['Boolean']
  showOnlyStarred: Scalars['Boolean']
  showOnlyUnread: Scalars['Boolean']
  sortBy: ViewOptionsSortByType
}

export type ViewOptionsInput = {
  hideMessaged?: InputMaybe<Scalars['Boolean']>
  hideNotInterested?: InputMaybe<Scalars['Boolean']>
  hidePoorFit?: InputMaybe<Scalars['Boolean']>
  hideResponsesClosed?: InputMaybe<Scalars['Boolean']>
  showOnlyGoodFit?: InputMaybe<Scalars['Boolean']>
  showOnlyStarred?: InputMaybe<Scalars['Boolean']>
  showOnlyUnread?: InputMaybe<Scalars['Boolean']>
  sortBy?: InputMaybe<ViewOptionsSortByType>
}

export enum ViewOptionsSortByType {
  BestFit = 'BEST_FIT',
  EarliestEventDate = 'EARLIEST_EVENT_DATE',
  HighestBudget = 'HIGHEST_BUDGET',
  MostRecent = 'MOST_RECENT',
}
